import React from "react";
import { Button, Modal } from "react-bootstrap";

export const PaymentFailure = ({ show, onHide, props }) => {
    return (
        <Modal
            show={show}
            onHide={() => onHide(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className="VerificationPage VerifiedVerification">
                    <div className="page-content text-center">
                        <img src={require('../../assets/elfo-mascot-logo.png')} alt="..." />
                        <h3>Payment was unsuccessful!</h3>

                        <p>Your payment was unsuccessful</p>

                        <p>Try again by clicking the button below</p>

                        <div className="d-flex justify-content-center align-items-center gap-1">
                            <Button
                                variant="primary"
                                onClick={() => onHide(false)}
                            > Close
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
};
